import { klaviyoLogEvent } from "./amplitude/amplitudeAnalytics";

const KLAVIYO_EVENTS = {
  SUBSCRIBE_CONSENT_LIST: "Subscribe_Consent_List",
  DOB_SETUP: "DOB_Setup",
};

export function subscribeKlaviyoList(email: string, tag: string, userLanguage: string, props: any = {}) {
  const properties = {
    email, tag, userLanguage, ...props,
  };
  klaviyoLogEvent(KLAVIYO_EVENTS.SUBSCRIBE_CONSENT_LIST, properties);
}

export function setAccountDOBEvent(accountDetails: any) {
  klaviyoLogEvent(KLAVIYO_EVENTS.DOB_SETUP, accountDetails);
}
